/*
 * Copyright © 2021-present Tacnode Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Tacnode Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Tacnode Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { Button, Form } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LinkWithParams } from '@/components/Navigator/LinkWithParams'
import { PasswordChangingForm } from '@/pages/sign/features/PasswordChangingForm'

export function ForgotPassword() {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  return (
    <div className="signin-container">
      <div className="center-center">
        <h2>{t('Forgot Password')}</h2>
      </div>
      <PasswordChangingForm setLoading={setLoading} size="large">
        <Form.Item>
          <Button block type="primary" htmlType="submit" loading={loading} size="large">
            {t('Update Password')}
          </Button>
        </Form.Item>
        <div className="flex-end-center">
          <LinkWithParams to="/signin">{t('Back to Sign in')}</LinkWithParams>
        </div>
      </PasswordChangingForm>
    </div>
  )
}
